
document.addEventListener('DOMContentLoaded', function() {
  const quantityInput = document.getElementById('quantity');
  const radioButtons = document.querySelectorAll('.v-bundle-input');
  const quantityIcons = document.querySelectorAll('.quantity-icon');
  const bundleItems = document.querySelectorAll('.v-bundle-item');
  const productQuantitySelector = document.querySelector('.product-quantity__selector');
  const productPriceOriginalElement = document.getElementById('p-calculated-original');
  const productPriceSaleElement = document.getElementById('p-calculated-sale'); 
  const savingsDifferenceElement = document.getElementById('difference');

  quantityIcons.forEach(icon => icon.addEventListener('click', handleQuantityIconClick));
  radioButtons.forEach(radio => radio.addEventListener('click', handleRadioButtonClick));
  quantityInput.addEventListener('input', updateProductPrice);

  const originalUnitPrice = parseFloat(productPriceOriginalElement.textContent.replace(/[^\d.-]/g, ''));

  function handleQuantityIconClick(event) {
    const isPlus = event.target.id === 'plus';
    const currentValue = parseInt(quantityInput.value);
    quantityInput.value = isPlus ? currentValue + 1 : Math.max(currentValue - 1, 1);
    updateRadioButtons();
    updateCheckedStatus();
    updateProductQuantitySelectorValue();
    updateProductPrice();
  }

  function handleRadioButtonClick(event) {
    const clickedRadio = event.target;
    const clickedValue = parseInt(clickedRadio.value);
    radioButtons.forEach(radio => radio.checked = false);
    clickedRadio.checked = true;
    quantityInput.value = clickedValue;
    updateRadioButtons();
    updateCheckedStatus();
    updateProductQuantitySelectorValue();
    updateProductPrice();

    const quantity = parseInt(quantityInput.value);
    toggleElementsBasedOnQuantity(quantity);
  }

  function updateRadioButtons() {
    const currentValue = parseInt(quantityInput.value);
    radioButtons.forEach(radio => radio.checked = currentValue >= parseInt(radio.value));
  }

  function updateCheckedStatus() {
    bundleItems.forEach(item => {
      const radioInput = item.querySelector('.v-bundle-input');
      const classList = item.classList;
      const optionRadio = item.querySelector('.option-radio');

      if (radioInput.checked) {
        classList.add('checked');
        optionRadio.classList.add('checked');
      } else {
        classList.remove('checked');
        optionRadio.classList.remove('checked');
      }
    });
  }

  function updateProductQuantitySelectorValue() {
    productQuantitySelector.value = quantityInput.value;
  }

  function toggleElementsBasedOnQuantity(quantity) {
    const pPriceCardElement = document.getElementById('p-price-card');
    const pDiscountElement = document.getElementById('p-info-note');
    const differenceElement = document.getElementById('difference');

    if (quantity >= 7) {
      differenceElement.style.opacity = '1';
      pDiscountElement.style.display = 'none';
      pPriceCardElement.style.opacity = 1;
    } else if (quantity >= 5) {
      differenceElement.style.opacity = '1';
      pDiscountElement.style.display = 'none';
      pPriceCardElement.style.opacity = 1;
    } else if (quantity >= 3) {
      differenceElement.style.opacity = '1';
      pDiscountElement.style.display = 'none';
      pPriceCardElement.style.opacity = 1;
    } else {
      differenceElement.style.opacity = '0';
      pDiscountElement.style.display = 'block';
      pPriceCardElement.style.opacity = 0;
    }
  }

  function updateProductPrice() {
    const quantity = parseInt(quantityInput.value);
    const totalPriceOriginal = (quantity * originalUnitPrice).toFixed(2);
    productPriceOriginalElement.textContent = `${totalPriceOriginal}`;

    let discountPercentage = 0;

    if (quantity >= 7) {
      discountPercentage = 10;
    } else if (quantity >= 5) {
      discountPercentage = 7;
    } else if (quantity >= 3) {
      discountPercentage = 5;
      savingsDifferenceElement.style.opacity = '1';
      document.getElementById('p-info-note').style.display = 'none';
      document.getElementById('p-price-card').style.opacity = 1;
    } else {
      savingsDifferenceElement.style.opacity = '0';
      document.getElementById('p-info-note').style.display = 'block';
      document.getElementById('p-price-card').style.opacity = 0;
    }

    const discountedPrice = totalPriceOriginal * (1 - discountPercentage / 100);
    const salePrice = discountedPrice.toFixed(2);
    productPriceSaleElement.textContent = `${salePrice}`;

    const difference = (totalPriceOriginal - salePrice).toFixed(2);
    savingsDifferenceElement.textContent = `Du sparst CHF ${difference}`;
  }

  updateProductPrice();
});

